import type { ComponentProps } from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

// Protocol button looks, layered on the shared Button instead of editing it.
// Hover lives in the state layer, so each variant repeats its colours to beat ghost's.
const VARIANT = {
  'primary-dark':
    'bg-[var(--surface-action)] border border-[var(--border-action)] text-[var(--text-on-action)] hover:bg-[var(--surface-action)] hover:text-[var(--text-on-action)]',
  // Disabled is grey, not a faded green, so it overrides Button's own opacity.
  'primary-green':
    'bg-[var(--green-600)] border border-[var(--green-400)] text-[var(--text-on-action)] hover:bg-[var(--green-600)] hover:text-[var(--text-on-action)] disabled:border-transparent disabled:bg-[var(--grey-40)] disabled:text-[var(--grey-80)] disabled:opacity-100',
  secondary:
    'bg-[var(--surface-white)] border border-[var(--border-default)] text-[var(--text-headings)] hover:bg-[var(--surface-white)] hover:text-[var(--text-headings)]',
  tertiary: 'bg-transparent border-0 text-[var(--text-body)] hover:bg-transparent hover:text-[var(--text-body)]'
} as const;

// 28px in the header and panels, 32px on the listing page, 28px circle for icon-only controls.
const SIZE = {
  md: 'h-7 gap-2 px-3 py-1 text-[13px] leading-4.5 has-[>svg]:px-3',
  lg: 'h-8 gap-2 px-4 py-1 text-[13px] leading-4.5 has-[>svg]:px-4',
  icon: 'size-7 p-0'
} as const;

export function ProtocolButton({
  variant = 'secondary',
  size = 'md',
  className,
  ...props
}: Omit<ComponentProps<typeof Button>, 'variant' | 'size'> & { variant?: keyof typeof VARIANT; size?: keyof typeof SIZE }) {
  return <Button variant='ghost' className={cn('protocol-btn', VARIANT[variant], SIZE[size], className)} {...props} />;
}
